import { render, staticRenderFns } from "./EditCharges.vue?vue&type=template&id=003bb4a2&scoped=true&"
import script from "./EditCharges.vue?vue&type=script&lang=js&"
export * from "./EditCharges.vue?vue&type=script&lang=js&"
import style0 from "./EditCharges.vue?vue&type=style&index=0&id=003bb4a2&scoped=true&lang=css&"
import style1 from "./EditCharges.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "003bb4a2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {
  VDataTable,
  VTextField,
})
